export const environment = {

  API_URL: 'https://api.kbimitation.com',
  IMAGE_URL: 'https://api.kbimitation.com/uploads/',
  BASE_URL: 'https://api.kbimitation.com/',
  SOCKET_URL: 'https://api.kbimitation.com/',
  SITE_URL: 'https://kbimitation.com',


  // API_URL: 'http://localhost:3000',
  // IMAGE_URL: 'http://localhost:3000/uploads/',
  // BASE_URL: 'http://localhost:3000/',
  // SOCKET_URL: 'http://localhost:3000/',

  defaultLang: "en",
};
